import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { searchSiteHeaders, filterColumns, searchSitesExpandedItems } from "utils/common";
import ResizableDataTable from "../common/desktopDataTable/resizableTable/resizableTable";
import { displayMobileRowItem } from "../common/mobileDataTable/utils";
import { updateSiteSearchFields } from "store/slices/siteRepo";

const SearchTable = () => {
  const dispatch = useDispatch();

  const { search } = useSelector((state) => state.siteRepo);
  const { results } = search;

  const tempFilterList = results.filter((row) => {
    const columnsTemp = filterColumns;
    return columnsTemp.some((column) => {
      const variable = row[column] == null ? "" : row[column].toString();
      return (
        variable
          .replace(/[^a-zA-Z0-9]/g, "")
          .toLowerCase()
          .indexOf(search.searchFilterValue.replace(/[^a-zA-Z0-9]/g, "").toLowerCase()) > -1
      );
    });
  });
  const filteredTableList = tempFilterList;

  const handleSearchFilter = (e) => {
    const value = e.target.value;
    const key = "searchFilterValue";
    dispatch(updateSiteSearchFields({ key, value }));
  };

  const siteRepoSearchMobileRows = (currentData) => {
    return currentData.map((row, index) => {
      return (
        <div className="mobile-data__row__column__item" key={index}>
          <div className="mobile-data__row__column__item__top hide-color">
            <div className="d-flex mobile-data__row__column__item__top__items">
              <div className="d-flex justify-content-between mobile-data__row__column__item__top__left ">
                <div
                  className="mobile-data__row__column__item__top__left__icon custom-collapse__container"
                  data-bs-toggle="collapse"
                  data-bs-target={"#collapse_" + row.siteId + index}
                  aria-expanded="false"
                  aria-controls={"#collapse_" + row.siteId + index}
                >
                  <span className="expand-collapse"></span>
                </div>
              </div>
              <div className="mobile-data__row__column__item__top__left__name">
                <span className="mobile-data__row__column__item__top__left__name--text">{row.siteName}</span>
              </div>
            </div>
          </div>
          <div className="collapse mobile-data__row__column__item__content" id={"collapse_" + row.siteId + index}>
            {searchSitesExpandedItems &&
              searchSitesExpandedItems.map((item, i) => {
                return (
                  <div key={i} className={`mobile-data__row__column__item__content__item ${item.classNameOne}`}>
                    <div className="mobile-data__row__column__item__content__item__flex">
                      <div className="mobile-data__row__column__item__content__item__flex--key">{item.keyName}:</div>
                      <div
                        className={`mobile-data__row__column__item__content__item__flex--value ${
                          item?.classNameTwo ? item.classNameTwo : ""
                        }`}
                      >
                        <span>{item.key}</span>
                        {item.keyName === "Site Name" ? (
                          <Link to={`/siteRepo/site/${row.siteId}`} className="sitename-link">
                            <span>{displayMobileRowItem(row, item)}</span>
                          </Link>
                        ) : (
                          displayMobileRowItem(row, item)
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      );
    });
  };
  return (
    <>
      <ResizableDataTable
        tableHeader={searchSiteHeaders}
        tableBody={results}
        renderMobileRows={siteRepoSearchMobileRows}
        countTitle="Search Results"
        displaySearchFilter={true}
        displaySectionTwo={false}
        isSelectAllChecked={false}
        filteredTableList={filteredTableList}
        searchFilterValue={search.searchFilterValue}
        handleSearchFilter={handleSearchFilter}
        expandedItems={searchSitesExpandedItems}
        component={"siteRepoSearch"}
      />
    </>
  );
};

export default SearchTable;
